import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Publication } from '../models/data.model';

@Injectable()
export class ContentService {

  constructor(private http: HttpClient) {}



  getScholarPublications(): Observable<Publication[]> {
    const url = '/assets/data/publications.json';
    return this.http.get<Publication[]>(url);
  }

  getPublications(): Observable<Publication[]> {
    const url = '/assets/data/publications-addition.json';
    return this.http.get<Publication[]>(url);
  }

  getSelectedProjects(): Observable<any> {
    const url = '/assets/data/front-page.json';
    return this.http.get<any[]>(url);
  }

  getCourses(): Observable<any[]> {
    const url = '/assets/data/courses.json';
    return this.http.get<any[]>(url);
  }

  getContactInfo(): Observable<any> {
    const url = '/assets/data/contact-info.json';
    return this.http.get<any[]>(url);
  }
}

